// modules
import React from "react";
import ReactDOM from "react-dom/client";
// styles
import "./index.css";
// components
import App from "./App/App";
// utils
import "./Utils/_styleVariables.scss";
// Services
import { AuthProvider } from "./Context/AuthContext";
import { CardProvider } from "./Context/CardContext";
import { BookPageImagesProvider } from "./Context/bookPagesContext";
import { TimerProvider } from "./Context/TimerContext";
import { ReadingTimeProvider } from "./Context/readingTimeContext";
import { QuarterlyPageImagesProvider } from "./Context/quarterlyPagesContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ReadingTimeProvider>
    <TimerProvider>
      <QuarterlyPageImagesProvider>
        <BookPageImagesProvider>
          <CardProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </CardProvider>
        </BookPageImagesProvider>
      </QuarterlyPageImagesProvider>
    </TimerProvider>
  </ReadingTimeProvider>
);
